import makeLevel from '../makeLevel.js';
import * as powerups from '../../powerups.js';

export default makeLevel([
  "bbbb*          *bbbb",
  "bbbb*          *bbbb",
  "!!!!*    **    *!!!!",
  "####************####",
  "    *    **    *    ",
  "    *          *    ",
  "bbbb#bbbbbbbbbb#bbbb",
  "****#!!!!!!!!!!#****",
  "****############****",
  "     bbbbbbbbbb     ",
  "      bbbbbbbb      ",
  "***    bbbbbb    ***",
  "!!***   bbbb   ***!!",
  "###!***  bb  ***!###",
  "  ###!********!###  ",
  "    ##!bbbbbb!##    ",
  "     #bbbbbbbb#     ",
  "        bbbb        ",
  "                    ",
  "                    "
], [
    {
        "2": powerups.paddleMini,
        "12": powerups.skipLevel,
        "16": powerups.ballSpeedDown,
        "19": powerups.ballSpeedDown,
        "25": powerups.instaDeath,
        "37": powerups.ballSpeedUp,
        "43": powerups.ballUnstopable,
        "47": powerups.ballSpeedUp,
        "48": powerups.ballSpeedDown,
        "49": powerups.ballExtra,
        "54": powerups.paddleSticky,
        "56": powerups.ballSpeedDown,
        "58": powerups.paddleGrow,
        "62": powerups.ballExploding,
        "81": powerups.ballExtra,
        "84": powerups.paddleSticky,
        "88": powerups.ballSpeedDown,
        "89": powerups.instaDeath,
        "117": powerups.paddleGrow,
        "120": powerups.paddleGrow,
        "122": powerups.ballExploding,
        "123": powerups.ballExtra,
        "124": powerups.paddleGrow,
        "128": powerups.ballSpeedDown,
        "129": powerups.ballSpeedDown,
        "140": powerups.ballUnstopable,
        "143": powerups.ballExtra,
        "145": powerups.weakenBlocks,
        "156": powerups.ballExtra,
        "158": powerups.instaDeath,
        "165": powerups.paddleMini,
        "167": powerups.paddleShrink,
        "170": powerups.paddleGrow,
        "172": powerups.ballSpeedDown,
        "175": powerups.paddleShrink,
        "186": powerups.paddleLasers,
        "200": powerups.ballSpeedUp,
        "204": powerups.paddleMini,
        "205": powerups.ballUnstopable
    },
    {
        "1": powerups.paddleShrink,
        "3": powerups.paddleShrink,
        "5": powerups.paddleSticky,
        "6": powerups.ballExploding,
        "7": powerups.paddleLasers,
        "9": powerups.paddleLasers,
        "26": powerups.ballSpeedDown,
        "27": powerups.ballSpeedUp,
        "28": powerups.extraLive,
        "29": powerups.ballSpeedDown,
        "30": powerups.ballExploding,
        "37": powerups.paddleShrink,
        "48": powerups.paddleGrow,
        "50": powerups.paddleSticky,
        "53": powerups.paddleSticky,
        "54": powerups.instaDeath,
        "56": powerups.ballSpeedDown,
        "58": powerups.ballSpeedDown,
        "62": powerups.ballExtra,
        "66": powerups.ballExploding,
        "85": powerups.paddleLasers,
        "86": powerups.paddleGrow,
        "88": powerups.ballUnstopable,
        "100": powerups.paddleGrow,
        "108": powerups.ballSpeedUp,
        "111": powerups.paddleGrow,
        "112": powerups.ballSpeedUp,
        "122": powerups.ballExtra,
        "123": powerups.lightning,
        "129": powerups.ballExtra,
        "131": powerups.paddleShrink,
        "132": powerups.paddleGrow,
        "133": powerups.paddleMini,
        "142": powerups.ballSpeedDown,
        "145": powerups.paddleShrink,
        "149": powerups.ballSpeedDown,
        "159": powerups.ballSpeedDown,
        "174": powerups.paddleSticky,
        "175": powerups.ballSpeedDown,
        "178": powerups.paddleSticky,
        "179": powerups.lightning,
        "180": powerups.ballUnstopable,
        "181": powerups.paddleShrink,
        "185": powerups.paddleShrink,
        "203": powerups.ballSpeedUp,
        "216": powerups.paddleSticky,
        "217": powerups.ballSpeedUp
    },
    {
        "2": powerups.ballSpeedUp,
        "5": powerups.ballExtra,
        "7": powerups.paddleShrink,
        "8": powerups.ballExtra,
        "14": powerups.ballSpeedUp,
        "25": powerups.lightning,
        "27": powerups.skipLevel,
        "30": powerups.ballExploding,
        "33": powerups.paddleGrow,
        "37": powerups.ballUnstopable,
        "42": powerups.paddleGrow,
        "44": powerups.paddleLasers,
        "48": powerups.paddleLasers,
        "54": powerups.paddleShrink,
        "55": powerups.paddleShrink,
        "58": powerups.ballSpeedDown,
        "59": powerups.skipLevel,
        "62": powerups.paddleGrow,
        "63": powerups.paddleMini,
        "67": powerups.ballExtra,
        "77": powerups.lightning,
        "83": powerups.paddleGrow,
        "87": powerups.ballSpeedDown,
        "106": powerups.ballUnstopable,
        "118": powerups.weakenBlocks,
        "121": powerups.ballUnstopable,
        "123": powerups.ballExtra,
        "129": powerups.paddleShrink,
        "137": powerups.paddleLasers,
        "142": powerups.paddleShrink,
        "147": powerups.ballSpeedDown,
        "149": powerups.ballSpeedDown,
        "152": powerups.ballExtra,
        "153": powerups.ballSpeedUp,
        "158": powerups.paddleShrink,
        "159": powerups.paddleLasers,
        "162": powerups.paddleSticky,
        "163": powerups.ballSpeedUp,
        "173": powerups.ballExtra,
        "175": powerups.instaDeath,
        "176": powerups.ballExploding,
        "187": powerups.ballSpeedUp,
        "189": powerups.ballExtra,
        "193": powerups.ballExploding,
        "196": powerups.ballExtra,
        "203": powerups.ballSpeedUp,
        "204": powerups.paddleSticky,
        "209": powerups.paddleGrow,
        "214": powerups.paddleShrink
    },
    {
        "0": powerups.instaDeath,
        "3": powerups.ballSpeedDown,
        "9": powerups.ballExploding,
        "11": powerups.ballSpeedUp,
        "24": powerups.paddleGrow,
        "27": powerups.paddleShrink,
        "30": powerups.paddleLasers,
        "31": powerups.ballSpeedDown,
        "32": powerups.ballSpeedDown,
        "35": powerups.ballExtra,
        "37": powerups.ballSpeedUp,
        "51": powerups.ballExtra,
        "52": powerups.ballSpeedUp,
        "59": powerups.instaDeath,
        "60": powerups.paddleMini,
        "62": powerups.paddleGrow,
        "67": powerups.paddleSticky,
        "69": powerups.ballSpeedDown,
        "70": powerups.ballSpeedDown,
        "74": powerups.instaDeath,
        "76": powerups.paddleSticky,
        "79": powerups.paddleLasers,
        "81": powerups.paddleShrink,
        "85": powerups.ballSpeedDown,
        "98": powerups.ballExploding,
        "101": powerups.weakenBlocks,
        "103": powerups.instaDeath,
        "108": powerups.weakenBlocks,
        "110": powerups.ballSpeedUp,
        "111": powerups.lightning,
        "118": powerups.ballSpeedUp,
        "121": powerups.ballExploding,
        "122": powerups.paddleGrow,
        "136": powerups.instaDeath,
        "140": powerups.paddleShrink,
        "141": powerups.ballSpeedDown,
        "144": powerups.ballSpeedUp,
        "150": powerups.paddleLasers,
        "151": powerups.paddleGrow,
        "158": powerups.ballUnstopable,
        "165": powerups.ballSpeedDown,
        "170": powerups.paddleMini,
        "200": powerups.ballSpeedUp,
        "205": powerups.ballUnstopable,
        "206": powerups.paddleGrow,
        "208": powerups.paddleSticky,
        "210": powerups.paddleMini,
        "216": powerups.ballSpeedUp,
        "219": powerups.ballSpeedDown
    },
    {
        "0": powerups.paddleShrink,
        "7": powerups.paddleGrow,
        "12": powerups.paddleGrow,
        "20": powerups.paddleMini,
        "26": powerups.instaDeath,
        "38": powerups.paddleShrink,
        "44": powerups.ballExtra,
        "45": powerups.paddleLasers,
        "51": powerups.paddleMini,
        "56": powerups.paddleSticky,
        "61": powerups.paddleMini,
        "69": powerups.paddleShrink,
        "75": powerups.ballExtra,
        "90": powerups.paddleShrink,
        "93": powerups.ballSpeedDown,
        "118": powerups.ballUnstopable,
        "123": powerups.ballExtra,
        "125": powerups.ballSpeedUp,
        "127": powerups.weakenBlocks,
        "129": powerups.paddleShrink,
        "132": powerups.paddleGrow,
        "141": powerups.ballExtra,
        "149": powerups.ballExtra,
        "152": powerups.ballSpeedUp,
        "155": powerups.paddleMini,
        "157": powerups.ballSpeedDown,
        "158": powerups.ballUnstopable,
        "164": powerups.paddleShrink,
        "168": powerups.ballExploding,
        "179": powerups.ballSpeedDown,
        "182": powerups.ballExtra,
        "185": powerups.paddleGrow,
        "187": powerups.paddleGrow,
        "192": powerups.paddleLasers,
        "204": powerups.ballExtra,
        "213": powerups.paddleShrink
    },
    {
        "7": powerups.paddleGrow,
        "10": powerups.paddleMini,
        "11": powerups.paddleSticky,
        "19": powerups.paddleGrow,
        "42": powerups.weakenBlocks,
        "46": powerups.paddleSticky,
        "47": powerups.paddleGrow,
        "53": powerups.paddleGrow,
        "55": powerups.paddleShrink,
        "59": powerups.paddleMini,
        "65": powerups.ballExtra,
        "74": powerups.paddleGrow,
        "80": powerups.paddleShrink,
        "81": powerups.ballUnstopable,
        "83": powerups.ballExploding,
        "91": powerups.ballSpeedUp,
        "103": powerups.paddleGrow,
        "104": powerups.paddleShrink,
        "108": powerups.ballUnstopable,
        "110": powerups.ballSpeedUp,
        "114": powerups.paddleGrow,
        "118": powerups.paddleShrink,
        "119": powerups.ballSpeedUp,
        "126": powerups.ballExploding,
        "134": powerups.ballExtra,
        "140": powerups.paddleShrink,
        "141": powerups.ballSpeedUp,
        "144": powerups.ballUnstopable,
        "148": powerups.ballSpeedDown,
        "149": powerups.ballSpeedUp,
        "160": powerups.paddleLasers,
        "165": powerups.instaDeath,
        "170": powerups.paddleShrink,
        "171": powerups.paddleMini,
        "172": powerups.ballExploding,
        "175": powerups.paddleGrow,
        "192": powerups.lightning,
        "193": powerups.paddleShrink,
        "199": powerups.ballSpeedUp,
        "210": powerups.paddleGrow,
        "211": powerups.instaDeath,
        "219": powerups.ballSpeedDown
    },
    {
        "2": powerups.ballExtra,
        "4": powerups.ballExploding,
        "19": powerups.paddleShrink,
        "20": powerups.paddleSticky,
        "21": powerups.lightning,
        "29": powerups.paddleShrink,
        "32": powerups.ballSpeedUp,
        "42": powerups.ballExtra,
        "50": powerups.paddleGrow,
        "53": powerups.ballUnstopable,
        "68": powerups.paddleShrink,
        "73": powerups.ballSpeedDown,
        "81": powerups.ballSpeedUp,
        "91": powerups.ballExtra,
        "96": powerups.ballExploding,
        "104": powerups.paddleShrink,
        "105": powerups.lightning,
        "111": powerups.ballSpeedUp,
        "115": powerups.ballUnstopable,
        "125": powerups.ballSpeedUp,
        "129": powerups.ballUnstopable,
        "131": powerups.lightning,
        "133": powerups.ballSpeedUp,
        "134": powerups.ballSpeedUp,
        "135": powerups.weakenBlocks,
        "138": powerups.ballSpeedDown,
        "146": powerups.lightning,
        "147": powerups.ballSpeedDown,
        "149": powerups.ballSpeedUp,
        "151": powerups.paddleLasers,
        "155": powerups.ballExploding,
        "174": powerups.ballExploding,
        "178": powerups.ballExploding,
        "182": powerups.ballSpeedUp,
        "183": powerups.paddleGrow,
        "187": powerups.ballExtra,
        "189": powerups.lightning,
        "190": powerups.ballSpeedUp,
        "192": powerups.ballSpeedUp,
        "197": powerups.paddleGrow,
        "204": powerups.ballExtra,
        "207": powerups.paddleShrink,
        "209": powerups.lightning,
        "215": powerups.ballExtra,
        "218": powerups.paddleLasers
    },
    {
        "1": powerups.weakenBlocks,
        "9": powerups.paddleMini,
        "11": powerups.paddleLasers,
        "15": powerups.paddleShrink,
        "16": powerups.ballExtra,
        "19": powerups.paddleShrink,
        "26": powerups.paddleLasers,
        "28": powerups.ballSpeedDown,
        "33": powerups.paddleMini,
        "34": powerups.ballExploding,
        "35": powerups.paddleShrink,
        "39": powerups.ballExtra,
        "42": powerups.paddleShrink,
        "48": powerups.paddleShrink,
        "57": powerups.weakenBlocks,
        "59": powerups.ballExtra,
        "72": powerups.ballExtra,
        "79": powerups.ballExtra,
        "85": powerups.ballSpeedDown,
        "90": powerups.ballSpeedDown,
        "93": powerups.ballExploding,
        "95": powerups.ballExtra,
        "99": powerups.weakenBlocks,
        "104": powerups.ballSpeedUp,
        "106": powerups.paddleShrink,
        "108": powerups.paddleGrow,
        "109": powerups.paddleLasers,
        "110": powerups.instaDeath,
        "111": powerups.ballSpeedDown,
        "115": powerups.paddleShrink,
        "121": powerups.paddleMini,
        "122": powerups.ballExtra,
        "128": powerups.paddleShrink,
        "130": powerups.paddleShrink,
        "139": powerups.paddleSticky,
        "140": powerups.paddleMini,
        "149": powerups.paddleLasers,
        "151": powerups.paddleShrink,
        "156": powerups.ballSpeedDown,
        "164": powerups.ballExtra,
        "166": powerups.paddleShrink,
        "167": powerups.ballExploding,
        "169": powerups.ballSpeedDown,
        "173": powerups.ballExtra,
        "175": powerups.lightning,
        "176": powerups.ballUnstopable,
        "179": powerups.paddleLasers,
        "184": powerups.ballSpeedUp,
        "193": powerups.weakenBlocks,
        "195": powerups.paddleShrink,
        "196": powerups.paddleShrink,
        "201": powerups.ballExploding,
        "207": powerups.ballExploding,
        "211": powerups.ballExtra,
        "218": powerups.instaDeath
    }
]);
